// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__28A2y","switchMark":"styles_switchMark__1zG0M"};